<div class="stepper-header-bar">
  <div class="stepper-header-content">
    <div class="stepper-header-labels">
      <div class="stepper-header-title">
        {{ title }}
      </div>
      <div class="stepper-header-subtitle">
        {{ steps[step]?.label || "" }} Details
      </div>
    </div>
    <div class="stepper-header-step">
      Step {{ step + 1 }} of {{ steps.length }}
    </div>
  </div>
  <div class="stepper-progress-bar-wrapper">
    <div class="stepper-progress-bar">
      <div
        class="stepper-progress-bar-fill"
        [style.width]="((step + 1) / steps.length) * 100 + '%'"
      ></div>
    </div>
  </div>
</div>
